// Wedding Date PPLR Protection Script
(function() {
  'use strict';
  
  // Function to protect wedding date properties from pplr
  function protectWeddingDateProperties() {
    // Find all wedding date property elements
    const weddingDateElements = document.querySelectorAll('[data-pplr-exclude="true"]');
    
    weddingDateElements.forEach(function(element) {
      // Remove any pplr classes and attributes that might be added
      element.classList.remove('a_pplr_item_price');
      element.removeAttribute('pplr_set_price');
      element.removeAttribute('data-line');
      
      // Create a MutationObserver to watch for pplr modifications
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes') {
            // Remove pplr attributes if they're added
            if (mutation.attributeName === 'class' && element.classList.contains('a_pplr_item_price')) {
              element.classList.remove('a_pplr_item_price');
            }
            if (mutation.attributeName === 'pplr_set_price') {
              element.removeAttribute('pplr_set_price');
            }
            if (mutation.attributeName === 'data-line') {
              element.removeAttribute('data-line');
            }
          }
          if (mutation.type === 'childList') {
            // If pplr tries to replace the text content, restore original
            const originalText = element.getAttribute('data-original-text');
            if (originalText && element.textContent !== originalText) {
              // Check if the content looks like a price (contains currency symbols)
              if (element.textContent.includes('¥') || element.textContent.includes('$') || element.textContent.includes('€')) {
                element.textContent = originalText;
              }
            }
          }
        });
      });
      
      // Store original text content
      element.setAttribute('data-original-text', element.textContent);
      
      // Start observing
      observer.observe(element, {
        attributes: true,
        childList: true,
        subtree: true
      });
    });
  }
  
  // Run protection on DOM load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', protectWeddingDateProperties);
  } else {
    protectWeddingDateProperties();
  }
  
  // Also run after any cart updates
  document.addEventListener('cart:updated', protectWeddingDateProperties);
  
  // Run periodically to catch any delayed pplr processing
  setInterval(protectWeddingDateProperties, 1000);
})();